import { AssignLicensesFailureType } from "@shared/types";

export const ASSIGN_LICENSE_FAILURE_TYPE_TO_DISPLAY: Record<
  AssignLicensesFailureType,
  string
> = {
  not_member: "licenses.errors.notMember",
  require_upgrade: "licenses.errors.requireUpgrade",
  general_error: "licenses.errors.generalError",
  missing_user: "licenses.errors.missingUser",
  downgrade_error: "licenses.errors.downgradeError",
  dca_running_error: "licenses.errors.dcaRunningError",
};

export const DELETE_INVITATION_CACHE_KAY = "delete-invitation";
export const ACTIVATE_INVITATION_CACHE_KAY = "activate-invitation";
export const DEACTIVATE_INVITATION_CACHE_KAY = "deactivate-invitation";
